const ApiSettingGroupEnum = {
  WEB  : 'web',
  ADMIN: 'admin',
  API  : 'api'
}

export default ApiSettingGroupEnum
